import Framework from '@greenville/framework';
import { applySnapshot, types } from 'mobx-state-tree';
import * as constants from '../../../common/constants';

const pvsIngestionStatus = types.model('pvsIngestionStatus', {
  code: types.maybeNull(types.string),
  text: types.maybeNull(types.string)
});

const pvsStatusMessages = types.model('pvsStatusMessages', {
  creationDt: types.maybeNull(types.string),
  messageTypeCode: types.maybeNull(types.string),
  manifestProcessingActivityType: types.maybeNull(types.string),
  manifestProcessingStatusCode: types.maybeNull(types.string),
  createdBy: types.maybeNull(types.string)
});

const pvsIngestionActivities = types.model('pvsIngestionActivities', {
  type: types.maybeNull(types.string),
  statusMessages: types.maybeNull(types.array(types.optional(pvsStatusMessages, {})))
});

const ingestionData = types.model('ingestionData', {
  manifestId: types.maybeNull(types.string),
  courseId: types.maybeNull(types.string),
  trackingId: types.maybeNull(types.string),
  activities: types.maybeNull(types.array(pvsIngestionActivities)),
  updatedAt: types.maybeNull(types.string),
  status: types.maybeNull(pvsIngestionStatus),
  statusCode: types.maybeNull(types.string)
});

const IngestionStatusModel = types
  .model('IngestionStatusModel', {
    data: types.optional(types.array(ingestionData), []),
    page: types.maybeNull(types.number),
    total: types.maybeNull(types.number)
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.GET_SEARCH_INGESTION_RESPONSE, {
        payload
      });
    },
    setResponse(response) {
      const resultData = response?.data?.data?.data;
      if (resultData) {
        /* eslint-disable */
        const pvsData = resultData.map((item) => {
          let safeStatus = item.status;
          if (!safeStatus.code) {
            safeStatus = { code: item.status, text: '' };
          }
          const dataToReturn = {
            manifestId: item.contentPublishMessage.payload.manifestId,
            trackingId: item.trackingId,
            courseId: item.contentPublishMessage.payload.courseId,
            updatedAt: new Date(item.updatedAt).toLocaleString(),
            activities: item?.activities?.map((activity) => {
              const lastObject = activity.statusMessages[activity.statusMessages.length - 1];
              const newObject = lastObject.payload
                ? {
                    creationDt: lastObject.payload.creationDt,
                    manifestProcessingStatusCode: lastObject.payload.manifestProcessingStatusCode
                  }
                : {
                    creationDt: lastObject.creationDt,
                    manifestProcessingStatusCode: lastObject.manifestProcessingStatusCode
                  };
              return {
                ...activity,
                statusMessages: [newObject]
              };
            }),
            status: safeStatus
          };

          return dataToReturn;
        });
        /* eslint-disable */
        const result = {
          data: pvsData,
          page: response?.data?.data?.page,
          total: response?.data?.data?.total
        };
        applySnapshot(self, result);
      } else {
        const result = {
          data: resultData,
          page: response?.data?.data?.page,
          total: response?.data?.data?.total
        };
        applySnapshot(self, result);
      }
      Framework.getEventManager().publish(constants.SET_SEARCH_INGESTION_RESPONSE);
    },
    resetStoreValues() {
      const initialState = [];
      applySnapshot(self.data, initialState);
    }
  }));

export default IngestionStatusModel;
